import { req,reqObj } from './axiosFun';
import { downLoadReq }  from "./downLoad"
// --------------------------------2023.12.28 f反算月账单-----------------------------------------
// 手动推送反算账单信息到EIP
export const pushInverseBillToEip = (params) => { return req("post","/api/newMonthBillData/pushInverseBillToEip", params) };
// 查询  
export const list_alarm_config = (params) => { return req('get',"/api/alarm_config/list_alarm_config", params) };


// WEBPACK FOOTER //
// ./src/api/prepayment.js